import React from 'react';
import Card from '@/components/ui/Card';
import Navigation from '@/components/ui/Navigation';

interface PaginationProps {
  currentPage: number;
  totalCount: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  isLoading?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
  isLoading = false
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (isLoading || totalCount === 0) {
    return null;
  }

  return (
    <Card>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <label htmlFor="pagination-page-size" className="text-sm font-medium text-gray-700 dark:text-gray-200">Show:</label>
            <select
              id="pagination-page-size"
              className="input-field px-3 py-1 text-sm"
              value={pageSize} 
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
            >
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span className="text-sm text-gray-500">per page</span>
          </div>
          <div className="text-sm text-gray-500">
            Showing {((currentPage - 1) * pageSize) + 1}-{Math.min(currentPage * pageSize, totalCount)} of {totalCount} items
          </div>
        </div>
        
        <Navigation 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </Card>
  );
};

export default Pagination;
